import { component } from 'picoapp';
import Drawer from 'utils/drawer';
import ProductImage from '@grafikr/shopify-typescript/type/ProductImage';
import Variant from '@grafikr/shopify-typescript/type/Variant';
import { image } from 'utils/image';
import modifyCart from 'lib/modify-cart';

export default component(async (node) => {
  const productSelectors = node.querySelectorAll<HTMLElement>('[data-product-selector]');
  const form = node.querySelector('form');
  const visibleProperties = form.querySelectorAll<HTMLInputElement>('[data-visible-property]');
  const hiddenProperties = form.querySelectorAll<HTMLInputElement>('[data-hidden-property]');
  const submitBtn = form.querySelector<HTMLButtonElement>('[data-submit-btn]');

  interface ProductData {
    title: string,
    image: ProductImage,
    variants: Variant[],
  }

  interface SelectorBtnContent {
    productTitle: string,
    variantTitle: string,
    image: ProductImage,
  }

  const initSubmit = () => {
    const submit = async (event: Event) => {
      event.preventDefault();

      const formData = new FormData(form);
      await modifyCart('add', formData);
    };

    form.addEventListener('submit', submit);
  };

  const initUpdateSubmit = () => {
    const updateSubmit = () => {
      const allSettled = Array.from(hiddenProperties).every((input) => (
        input.value !== ''
      ));

      if (allSettled) {
        submitBtn.disabled = false;
      }
    };

    hiddenProperties.forEach((input) => {
      input.addEventListener('change', updateSubmit);
    });
  };

  const initProductSelectors = () => {
    const updateSelectorBtn = (btn: HTMLButtonElement, content: SelectorBtnContent) => {
      btn.innerHTML = `<div class="flex flex-col items-center">
        <div class="absolute top-5 right-5">
          ${theme.icons.edit}
        </div>

        <div class="w-24">
          <div class="aspect-ratio aspect-ratio--1/1">${image(content.image)}</div>
        </div>

        <div class="mt-2 text-sm">
          <p class="font-medium">${content.productTitle}</p>
          <p class="text-gray-500">${content.variantTitle}</p>
        </div>
      </div>`;
    };

    const selectVariant = (productItem: HTMLElement, selector: HTMLElement) => {
      const selectorIndex = selector.dataset.index;
      const variantSelect = productItem.querySelector<HTMLSelectElement>('[data-variant-select]');
      const variantId = parseInt(variantSelect.value, 10);
      const productDataElement = productItem.querySelector('[data-product-data]');
      const productData: ProductData = JSON.parse(productDataElement.innerHTML);

      const selectedVariant = productData.variants.find((variant) => (
        variant.id === variantId
      ));

      const matchIndex = (elements: NodeListOf<HTMLElement>, index: string) => {
        const matchingElement = Array.from(elements).find((element) => (
          element.dataset.index === index
        ));

        return matchingElement;
      };

      const visibleProperty = matchIndex(visibleProperties, selectorIndex) as HTMLInputElement;
      const hiddenProperty = matchIndex(hiddenProperties, selectorIndex) as HTMLInputElement;

      visibleProperty.value = `${productData.title} - ${selectedVariant.title}`;
      hiddenProperty.value = `${selectedVariant.sku}`;

      hiddenProperty.dispatchEvent(new Event('change'));

      const selectorBtn = selector.querySelector<HTMLButtonElement>('[data-selector-btn]');

      updateSelectorBtn(selectorBtn, {
        productTitle: productData.title,
        variantTitle: selectedVariant.title,
        image: productData.image,
      });

      document.dispatchEvent(new Event('drawers:close'));
    };

    productSelectors.forEach((selector) => {
      const selectorBtn = selector.querySelector('[data-selector-btn]');
      const drawerElement = selector.querySelector<HTMLElement>('[data-drawer]');
      const drawerCloseBtn = selector.querySelector('[data-drawer-close-btn]');
      const productItems = selector.querySelectorAll<HTMLElement>('[data-product-item]');

      document.body.appendChild(drawerElement);
      const drawer = Drawer(drawerElement);

      selectorBtn.addEventListener('click', () => drawer.open());
      drawerCloseBtn.addEventListener('click', () => drawer.close());

      document.addEventListener('drawers:close', () => drawer.close());

      productItems.forEach((item) => {
        const links = item.querySelectorAll('a');
        const selectVariantBtn = item.querySelector('[data-select-variant-btn]');

        links.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            selectVariant(item, selector);
          });
        });

        selectVariantBtn.addEventListener('click', () => selectVariant(item, selector));
      });
    });
  };

  const init = () => {
    initSubmit();
    initUpdateSubmit();
    initProductSelectors();
  };

  init();
});
